export enum ENUM_DELIVERYMAN_STATUS {
  OFFLINE = 'OFFLINE',
  PRECADASTRO = 'PRECADASTRO',
  BLOQUEADO = 'BLOQUEADO',
  EM_CORRIDA = 'EM_CORRIDA',
  ENTREGA_ASSOCIADA = 'ENTREGA_ASSOCIADA',
  DISPONIVEL = 'DISPONIVEL',
  REPROVADO = 'REPROVADO',
  EXCLUIDO = 'EXCLUIDO',
}
